import { render, staticRenderFns } from "./SiteImageAssetsComponent.vue?vue&type=template&id=459ad36c&"
import script from "./SiteImageAssetsComponent.vue?vue&type=script&lang=js&"
export * from "./SiteImageAssetsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports